module.exports = __webpack_public_path__ + "img/ic_football_formation_cloth_away.55c5e50c.png";